import { useState } from 'react'

import { ScoredCreditCardProduct } from '@ilg-totallymoney/types'

import Modal from '@ilg-totallymoney/ui/components/Modal'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'
import EligibilityIndicator from '@ilg-totallymoney/ui/productTable/components/EligibilityIndicator'

const EligibilityIndicatorWithModal = ({
    score,
}: {
    score: ScoredCreditCardProduct['score']
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <>
            <EligibilityIndicator
                score={score * 10}
                onClick={() => setIsModalOpen(true)}
            />
            {isModalOpen && (
                <Modal
                    hasTooltipHeader={true}
                    isOpen={true}
                    onClose={() => setIsModalOpen(false)}
                    isFullScreen={true}
                    title="What does my ‘eligibility’ for a credit product mean?"
                >
                    <Stack space="space10">
                        <Text>
                            Your eligibility is an indicator of how likely you
                            are to be accepted for a particular credit product
                            based on the acceptance levels of customers with
                            similar credit profiles to you.
                        </Text>
                        <Text>
                            The higher this rating, the more likely you are to
                            be accepted for the product. For example, if you
                            have an `excellent eligibility` this suggests you
                            have a high chance of being accepted, based on what
                            we know about customers like you, who have applied
                            for this product in the past.
                        </Text>
                        <Text>
                            Your eligibility does not guarantee that you will be
                            accepted, as lenders will make the final decision
                            when assessing your application.
                        </Text>
                    </Stack>
                </Modal>
            )}
        </>
    )
}

export default EligibilityIndicatorWithModal
